import React, { useEffect, useState } from "react";

import FaqData from "../femaleServices/FaqFemale.json"

// import img from "../../media/images/femaleService/wax/"
const FaqComponentFemale = ({ location }) => {
  const [show, setShow] = useState(false);


  const [viewAnswer , setViewAnswer] = useState(false)





  // console.log("FAQ Result ", checkLocation);

  return (
    <div>
      <div className=" faq faq-female-bg">
        <div>
          <div className="faq-heading faq-location-heading">
            FREQUENTLY ASKED QUESTIONS{" "}
          </div>

      

          <div className="Faq-location-home">
            <div className="Faq-location-content">


              {

                  FaqData&& FaqData.map((e ,i)=>(

                 <div className="Faq-location-content-row">
                <div className="Faq-location-questions" onClick={()=>setViewAnswer( viewAnswer === i ? null: i)}>
               Q{i+1}. {e.questions}


                  {

                      viewAnswer === i ?

                      <i class="fa-solid fa-minus"></i>
                      :
                      <i class="fa-solid fa-plus"></i>
                    
                  }

                </div>

                {

                  viewAnswer === i ?

                  <div className="Faq-location-answer">
                    <div> Ans: {e.answer} </div>

                        {
                            e.point && e.point.map((e,i)=>(
                                <p className="Faq-location-answer-fs-point"> •  {e}</p>
                            ))
                        }

                  </div>
                  :""
                }
              </div>
                  ))
                  
              }
          
            </div >
          </div>
          

          <a href="#services" className="landing-page-button-web-yellow">
            Book Service Now
          </a>

          <a href="#services" className="landing-page-button-mobile-yellow">
            Book Service Now
          </a>
        </div>
        
      </div>
    </div>
  );
};

export default FaqComponentFemale;


// export default FaqComponentFemale